import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { IonSlides } from '@ionic/angular';
import { User } from 'src/app/entities/User';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';

type Tutorial = {
  id: number;
  title: string;
  role: string;
  pages: TutorialPage[];
};

type TutorialPage = {
  id: number;
  title: string;
};

type TutorialHtml = {
  header: string;
  body: SafeHtml;
};

@Component({
  selector: 'app-tutorial-slide',
  templateUrl: './tutorial-slide.component.html',
  styleUrls: ['./tutorial-slide.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TutorialSlideComponent implements OnInit {
  @ViewChild('theSlides' , {static: false}) slides: IonSlides;

  @ViewChildren('slideContent') slideContent!: QueryList<ElementRef>;

  slideOpts = {
    speed: 400,
  };
  pages: TutorialPage[];
  htmlArray: TutorialHtml[] = [];
  tutorials: Tutorial[] = require('../../../assets/tutorial/tutorial.json');
  isPageOpen: boolean;
  isSlideOpen: boolean;
  last: TutorialHtml;
  first: TutorialHtml;
  currentUser: User;

  constructor(public http: HttpClient, private location: Location, private sanitizer: DomSanitizer) {
    this.isPageOpen = false;
    this.isSlideOpen = false;
  }

  ngOnInit() {
    this.isPageOpen = false;
    this.isSlideOpen = false;
  }

  async openPages(page: Tutorial) {
    this.isPageOpen = true;
    this.pages = page.pages;
    this.htmlArray = [];

    try {
      const requests = this.pages.map(slide =>
        firstValueFrom(
          this.http.get(`assets/tutorial/${page.id}/${slide.id}/${slide.id}.html`, {
            responseType: 'text'
          })
        )
      );

      const responses = await Promise.all(requests);

      this.htmlArray = responses.map((res, idx) => ({
        header: this.pages[idx].title,
        body: this.sanitizer.bypassSecurityTrustHtml(res),
      }));
   
    } catch (error) {
      console.error('Failed to load one or more tutorial pages:', error);
    }
  }


  openSlides(slide: TutorialPage) {
    this.last = this.htmlArray[this.htmlArray.length - 1];
    this.first = this.htmlArray[0];
    this.isSlideOpen = true;

    // Navigate to the specified slide and reset its scroll position to the top.
    this.slides.slideTo(slide.id - 1).then(() => {
      requestAnimationFrame(() => {
        const content = this.slideContent.get(slide.id - 1)?.nativeElement;
        content?.scrollTo({ top: 0});
    });
});
  }

  next() {
    this.slides.slideNext();
  }

  previous() {
    this.slides.slidePrev();
  }

  back() {
    if (this.isPageOpen && !this.isSlideOpen) {
      this.isPageOpen = false;
    } else if (this.isSlideOpen) {
      this.isSlideOpen = false;
    } else {
      this.location.back();
    }
  }

  close() {
    this.location.back();
  }
}
